<template>

  <div class="box box-primary">
    <div class="box-header">
      <h1>Informações do usuário</h1>
    </div>
    <div class="box-body">

      <fieldset>
        <legend>Usuário:</legend>
        <ul>
          <li v-if="usuario.name"><strong>Nome: </strong>{{ usuario.name }}</li>
          <li v-if="usuario.email"><strong>E-mail: </strong>{{ usuario.email }}</li>
          <li v-if="usuario.telefone"><strong>Telefone: </strong>{{ usuario.telefone }}</li>
          <li v-if="usuario.created_at"><strong>Criado: </strong>{{ usuario.created_at | moment("DD/MM/YYYY HH:mm") }}</li>
          <li v-if="usuario.updated_at"><strong>atualizado: </strong>{{ usuario.updated_at | moment("DD/MM/YYYY HH:mm") }}</li>
        </ul>
      </fieldset>
      
      <fieldset>
          <legend>Grupo:</legend>
          <ul>
            <li v-for="i in grupo">{{i.nome}}</li>
          </ul>
      </fieldset>

      <fieldset v-if="estado.length">
          <legend>Estado vinculado:</legend>
          <ul>
            <li v-for="i in estado">{{i.nome}}</li>
          </ul>
      </fieldset>

      <fieldset v-if="contrato.length">
          <legend>Contrato vinculado:</legend>
          <ul>
            <li v-for="i in contrato" v-if="i.numero_contrato">
              {{i.numero_contrato}}
            </li>
          </ul>
      </fieldset>
          
      </div>
    </div>

</template>

<script>
  export default {
    data () {
      return {
        usuario: this.$store.state.login.loginUsuario.usuario,
        grupo: this.$store.state.login.loginUsuario.grupo,
        estado: this.$store.state.login.loginUsuario.estado,
        contrato: this.$store.state.login.loginUsuario.contrato
      }
    }
  }
</script>

<style scoped>
fieldset {
    min-width: inherit;
    padding: 10px;
    margin: initial;
    border: 1px solid #ccc;
    border-radius: 0.5em;
}
legend {
  padding: 1em;
  display: inherit;
  width: inherit;
  max-width: inherit;
  margin-bottom: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  white-space: inherit;
  border-bottom: initial;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Perfil.vue?77e0e83c